// Components==============
import { faBook, faBriefcase, faUser } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SearchBar from 'components/UI/SearchBar';
import React, { useContext } from 'react';
import { VacanciesContext } from 'screens/Vacancies/Vacancies';
import Employment from './components/Employment';
import Function from './components/Function';
import Sector from './components/Sector';
import './FilterMenu.module.scss';
import Availability from './components/Availability';
// =========================

const Heading = ({ icon, children }) => (
    <div styleName="heading">
        <p>{children}</p>
        <FontAwesomeIcon icon={icon} />
    </div>
);

export default function FilterMenu() {
    const { searchValue, setSearchValue } = useContext(VacanciesContext);

    return (
        <div styleName="wrapper">
            <SearchBar
                searchValue={searchValue}
                setSearchValue={setSearchValue}
            />
            <div>
                <Heading icon={faBook}>Sector</Heading>
                <Sector />
            </div>
            <div>
                <Heading icon={faBriefcase}>Dienstverband</Heading>
                <Employment />
            </div>
            <div>
                <Heading icon={faUser}>Functie</Heading>
                <Function />
            </div>
            <div>
                <Heading icon={faUser}>Beschikbaarheid</Heading>
                <Availability />
            </div>
        </div>
    );
}
